import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { keepPreviousData, useQuery } from '@/proxy/react-query'
import { UseOrderEditPreview, OrderEditPreviewProducts } from './types'

type OrderEditPreviewOptions = {
  enabled?: boolean
  queryFn?: (variables: {
    orderNumber: string
    orderItemsInput: OrderEditPreviewProducts[]
  }) => Promise<UseOrderEditPreview>
}

export const ORDER_EDIT_PREVIEW = gql`
  query orderEditPreview(
    $orderNumber: String!
    $orderItemsInput: [UseOrderEditProducts!]!
  ) {
    orderEditPreview(
      orderNumber: $orderNumber
      orderItemsInput: $orderItemsInput
    ) {
      items {
        variantId
        name
        amount
        unitPrice
        totalPrice
        image
      }
      charging {
        shippingFee
        subTotal
        discount
        cashback
        change
        total
        totalSamplingPrice
      }
      errors {
        message
        category
        target
        key
      }
    }
  }
`

export const useOrderEditPreview = (
  variables: {
    orderNumber: string
    orderItemsInput: OrderEditPreviewProducts[]
  },
  options: OrderEditPreviewOptions = {}
) =>
  useQuery<UseOrderEditPreview>({
    queryKey: ['orderEditPreview', variables],
    queryFn: () =>
      options.queryFn?.(variables) ??
      client.request(ORDER_EDIT_PREVIEW, variables),
    placeholderData: keepPreviousData,
    enabled: options.enabled,
  })
